module.exports = __webpack_public_path__ + "static/media/contact-form.c324c83b.svg";